import { zodResolver } from '@hookform/resolvers/zod'
import { clsx } from 'clsx'
import { type ActionFunctionArgs, NavLink, Outlet } from 'react-router'
import { getValidatedFormData } from 'remix-hook-form'
import { z } from 'zod'
import { ContactUs } from '#app/components/layout/contact-us.tsx'
import { Header } from '#app/components/layout/Header.tsx'
import { ContactUsEmail } from '#app/emails/email-contact-us.tsx'
import { sendEmail } from '#app/utils/email.server.ts'

export const ContactUsSchema = z.object({
	name: z.string(),
	message: z.string(),
	email: z.string().email(),
	subject: z.string(),
})
export type ContactUsData = z.infer<typeof ContactUsSchema>
const resolver = zodResolver(ContactUsSchema)

export async function action({ request }: ActionFunctionArgs) {
	const { data, errors } = await getValidatedFormData<ContactUsData>(
		request,
		resolver,
	)
	if (!data || errors) {
		return { error: errors.message }
	}
	const { subject, ...formData } = data
	const response = await sendEmail({
		subject,
		to: process.env.AKADEMIE_CONTACT_EMAIL,
		from: formData.email,
		react: <ContactUsEmail formData={data} />,
	})
	return { response }
}

export default function ContactUsRoute() {
	return (
		<div className="flex min-h-screen flex-col">
			<div className="container">
				<Header />
			</div>
			<div className="flex-1">
				<Outlet />
			</div>
			<footer className="container hidden justify-end gap-8 pt-4 pb-2 md:flex">
				<ContactUs className="hover:text-pcteal-700 cursor-pointer text-gray-500" />
				<NavLink
					to="/datenschutz"
					className={({ isActive }) =>
						clsx(
							'hover:text-pcteal-700 text-gray-500',
							isActive && 'text-pcteal-default',
						)
					}
				>
					Datenschutz
				</NavLink>
				<NavLink
					to="/nutzungsbedingungen"
					className={({ isActive }) =>
						clsx(
							'hover:text-pcteal-700 text-gray-500',
							isActive && 'text-pcteal-default',
						)
					}
				>
					Nutzungsbedingungen
				</NavLink>
				<NavLink
					to="/impressum"
					className={({ isActive }) =>
						clsx(
							'hover:text-pcteal-700 text-gray-500',
							isActive && 'text-pcteal-default',
						)
					}
				>
					Impressum
				</NavLink>
			</footer>
		</div>
	)
}
